export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatAddress(address) {
  if (!address) return 'N/A';
  const phoneNumber = address.phone_number ? `Phone: ${address.phone_number}` : '';
  return `${address.address1 || ''} ${address.address2 || ''}, ${address.city || ''}, ${address.province || ''} ${address.zip || ''}, ${address.country || ''} ${phoneNumber}`.trim();
}

export function getStatusColor(status) {
  switch (status) {
    case 'unfulfilled': return '#ff5722';
    case 'preorder_received': return '#7b1fa2';
    case 'progress': return '#ff9800';
    case 'delay': return '#f57c00';
    case 'stock_in': return '#2e7d32';
    case 'packing': return '#ff9800';
    case 'shipping_domestic': return '#2196f3';
    case 'shipping_international': return '#2196f3';
    case 'arrived_at_destination': return '#1976d2';
    case 'out_of_delivery': return '#0288d1';
    case 'destoryed': return '#388e3c';
    case 'delivered': return '#4caf50';
    case 'review': return '#ff9800';
    case 'dispute': return '#e91e63';
    case 'replacement_approved': return '#6a1b9a';
    case 'replacement_packing': return '#ff9800';
    case 'replacement_shipping_domestic': return '#2196f3';
    case 'replacement_shipping_international': return '#2196f3';
    case 'replacement_delivered': return '#4caf50';
    case 'refunded': return '#4caf50';
    default: return '#757575';
  }
}

export function formatISTDateTime(iso) {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }).format(new Date(iso));
  } catch (_e) {
    return iso;
  }
}
